Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestionQuery = exports.isPropertyDefined = exports.handleResponseMSearch = exports.handleResponse = exports.handleError = exports.getQuerySuggestionsId = exports.isComponentActive = exports.handleTransformResponse = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.executeQueryListener = executeQueryListener;

var _constants = require('../../lib/utils/constants');

var _misc = require('./misc');

var _hits = require('./hits');

var _transform = require('../../lib/utils/transform');

var handleTransformResponse = exports.handleTransformResponse = function handleTransformResponse() {
  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var component = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (config.transformResponse && typeof config.transformResponse === 'function') {
    return config.transformResponse(res, component);
  }

  return new Promise(function (resolve) {
    return resolve(res);
  });
};

var isComponentActive = exports.isComponentActive = function isComponentActive() {
  var getState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var componentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var _getState = getState(),
      components = _getState.components;

  if (components.includes(componentId)) {
    return true;
  }

  return false;
};

var getQuerySuggestionsId = exports.getQuerySuggestionsId = function getQuerySuggestionsId() {
  var componentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return componentId + '__suggestions';
};

var handleError = exports.handleError = function handleError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$orderOfQueries = _ref.orderOfQueries,
      orderOfQueries = _ref$orderOfQueries === undefined ? [] : _ref$orderOfQueries,
      _ref$error = _ref.error,
      error = _ref$error === undefined ? null : _ref$error;

  var getState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var dispatch = arguments[2];

  var _getState2 = getState(),
      queryListener = _getState2.queryListener;

  try {
    console.error(JSON.stringify(error));
  } catch (e) {
    console.error(error);
  }

  orderOfQueries.forEach(function (component) {
    if (isComponentActive(getState, component)) {
      if (queryListener[component] && queryListener[component].onError) {
        queryListener[component].onError(error);
      }

      dispatch((0, _misc.setError)(component, error));
      dispatch((0, _misc.setLoading)(component, false));
    }
  });
};

var handleResponse = exports.handleResponse = function handleResponse() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      res = _ref2.res,
      _ref2$orderOfQueries = _ref2.orderOfQueries,
      orderOfQueries = _ref2$orderOfQueries === undefined ? [] : _ref2$orderOfQueries,
      _ref2$appendToHits = _ref2.appendToHits,
      appendToHits = _ref2$appendToHits === undefined ? false : _ref2$appendToHits,
      _ref2$appendToAggs = _ref2.appendToAggs,
      appendToAggs = _ref2$appendToAggs === undefined ? false : _ref2$appendToAggs,
      _ref2$isInternalCompo = _ref2.isInternalComponent,
      isInternalComponent = _ref2$isInternalCompo === undefined ? false : _ref2$isInternalCompo,
      _ref2$componentType = _ref2.componentType,
      componentType = _ref2$componentType === undefined ? '' : _ref2$componentType;

  var getState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var dispatch = arguments[2];

  var _getState3 = getState(),
      config = _getState3.config,
      internalValues = _getState3.internalValues;

  var suggestionsComponents = [_constants.componentTypes.dataSearch, _constants.componentTypes.categorySearch];
  var isSuggestionsQuery = isInternalComponent && suggestionsComponents.indexOf(componentType) !== -1;
  var searchId = res._headers ? res._headers.get('X-Search-Id') : null;

  if (searchId) {
    if (isSuggestionsQuery) {
      dispatch((0, _misc.setSuggestionsSearchId)(searchId));
    } else {
      dispatch((0, _misc.setSearchId)(searchId));
    }
  }

  orderOfQueries.forEach(function (component) {
    if (isComponentActive(getState, component)) {
      if (res.settings) {
        dispatch((0, _misc.setAppliedSettings)(res.settings, component));
      }

      handleTransformResponse(res[component], config, component).then(function (response) {
        if (response) {
          var _getState4 = getState(),
              timestamp = _getState4.timestamp;

          if (timestamp[component] === undefined || timestamp[component] < res._timestamp) {
            var promotedResults = response.promoted;

            if (promotedResults) {
              var parsedPromotedResults = promotedResults.map(function (promoted) {
                return _extends({}, promoted.doc, {
                  _position: promoted.position
                });
              });
              dispatch((0, _misc.setPromotedResults)(parsedPromotedResults, component));
            } else {
              dispatch((0, _misc.setPromotedResults)([], component));
            }

            dispatch((0, _misc.setRawData)(component, response));
            dispatch((0, _misc.setCustomData)(response.customData, component));

            if (response.hits) {
              dispatch((0, _misc.setTimestamp)(component, res._timestamp));
              dispatch((0, _hits.updateHits)(component, response.hits, response.took, response.hits && response.hits.hidden, appendToHits));
              var internalComponentID = (0, _transform.getInternalComponentID)(component);

              if (internalValues[internalComponentID]) {
                dispatch((0, _hits.saveQueryToHits)(component, internalValues[internalComponentID].value));
              }
            }

            if (response.aggregations) {
              dispatch((0, _hits.updateAggs)(component, response.aggregations, appendToAggs));
              dispatch((0, _hits.updateCompositeAggs)(component, response.aggregations, appendToAggs));
            }
          }

          dispatch((0, _misc.setLoading)(component, false));
        }
      }).catch(function (err) {
        handleError({
          orderOfQueries: orderOfQueries,
          error: err
        }, getState, dispatch);
      });
    }
  });
};

var handleResponseMSearch = exports.handleResponseMSearch = function handleResponseMSearch(_ref3) {
  var _ref3$res = _ref3.res,
      res = _ref3$res === undefined ? {} : _ref3$res,
      _ref3$isSuggestionsQu = _ref3.isSuggestionsQuery,
      isSuggestionsQuery = _ref3$isSuggestionsQu === undefined ? false : _ref3$isSuggestionsQu,
      _ref3$orderOfQueries = _ref3.orderOfQueries,
      orderOfQueries = _ref3$orderOfQueries === undefined ? [] : _ref3$orderOfQueries,
      _ref3$appendToHits = _ref3.appendToHits,
      appendToHits = _ref3$appendToHits === undefined ? false : _ref3$appendToHits,
      _ref3$appendToAggs = _ref3.appendToAggs,
      appendToAggs = _ref3$appendToAggs === undefined ? false : _ref3$appendToAggs;
  var getState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var dispatch = arguments[2];
  orderOfQueries.forEach(function (component, index) {
    if (isComponentActive(getState, component)) {
      var searchId = res._headers ? res._headers.get('X-Search-Id') : null;

      if (searchId) {
        if (isSuggestionsQuery) {
          dispatch((0, _misc.setSuggestionsSearchId)(searchId));
        } else {
          dispatch((0, _misc.setSearchId)(searchId));
        }
      }

      var transformResponse = res;

      if (res && Array.isArray(res.responses) && res.responses[index]) {
        transformResponse = res.responses[index];
      }

      var _getState5 = getState(),
          config = _getState5.config,
          internalValues = _getState5.internalValues;

      handleTransformResponse(transformResponse, config, component).then(function (response) {
        var _getState6 = getState(),
            timestamp = _getState6.timestamp;

        if (timestamp[component] === undefined || timestamp[component] < res._timestamp) {
          dispatch((0, _misc.setRawData)(component, response));
          var promotedResults = response.promoted || res.promoted;

          if (promotedResults) {
            dispatch((0, _misc.setPromotedResults)(promotedResults, component));
          } else {
            dispatch((0, _misc.setPromotedResults)([], component));
          }

          if (response.hits) {
            dispatch((0, _misc.setTimestamp)(component, res._timestamp));
            dispatch((0, _hits.updateHits)(component, response.hits, response.took, response.hits && response.hits.hidden, appendToHits));
            var internalComponentID = (0, _transform.getInternalComponentID)(component);

            if (internalValues[internalComponentID]) {
              dispatch((0, _hits.saveQueryToHits)(component, internalValues[internalComponentID].value));
            }
          }

          if (response.aggregations) {
            dispatch((0, _hits.updateAggs)(component, response.aggregations, appendToAggs));
            dispatch((0, _hits.updateCompositeAggs)(component, response.aggregations, appendToAggs));
          }
        }

        dispatch((0, _misc.setLoading)(component, false));
      }).catch(function (err) {
        handleError({
          orderOfQueries: orderOfQueries,
          error: err
        }, getState, dispatch);
      });
    }
  });
};

var isPropertyDefined = exports.isPropertyDefined = function isPropertyDefined(property) {
  return property !== undefined && property !== null;
};

var getSuggestionQuery = exports.getSuggestionQuery = function getSuggestionQuery() {
  var getState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var componentId = arguments[1];

  var _getState7 = getState(),
      internalValues = _getState7.internalValues;

  var internalValue = internalValues[componentId];
  var value = internalValue && internalValue.value || '';
  return [{
    id: getQuerySuggestionsId(componentId),
    dataField: ['key', 'key.autosuggest'],
    size: 5,
    value: value,
    defaultQuery: {
      query: {
        bool: {
          minimum_should_match: 1,
          should: [{
            function_score: {
              field_value_factor: {
                field: 'count',
                modifier: 'sqrt',
                missing: 1
              }
            }
          }, {
            multi_match: {
              fields: ['key^9', 'key.autosuggest^1', 'key.keyword^10'],
              fuzziness: 0,
              operator: 'or',
              query: value,
              type: 'best_fields'
            }
          }, {
            multi_match: {
              fields: ['key^9', 'key.autosuggest^1', 'key.keyword^10'],
              operator: 'or',
              query: value,
              type: 'phrase'
            }
          }, {
            multi_match: {
              fields: ['key^9'],
              operator: 'or',
              query: value,
              type: 'phrase_prefix'
            }
          }]
        }
      }
    }
  }];
};

function executeQueryListener(listener, oldQuery, newQuery) {
  if (listener && listener.onQueryChange) {
    listener.onQueryChange(oldQuery, newQuery);
  }
}